import {NgModule} from "@angular/core";
import {AboutModule as CoreAboutModule} from "@kwsoft/otcx-core";

import {AboutRoutingModule} from "./about-routing.module";

@NgModule({
    imports: [
        CoreAboutModule,
        AboutRoutingModule
    ]
})
export class AboutModule {
}
